export const ROW_LIMIT_DEFAULT = 10;

export const LEAD_SOURCE_TREE = [
  {
    value: "Direct Calling",
    title: "Direct Calling",
    children: [
      { value: "Outbound Call (Manual)", title: "Outbound Call (Manual)" },
      { value: "Inbound Call", title: "Inbound Call" },
      { value: "Inbound via Campaign", title: "Inbound via Campaign" },
    ],
  },
  {
    value: "Messaging & Campaigns",
    title: "Messaging & Campaigns",
    children: [
      { value: "SMS Campaign", title: "SMS Campaign" },
      { value: "WhatsApp Campaign", title: "WhatsApp Campaign" },
    ],
  },
  {
    value: "Referrals",
    title: "Referrals",
    children: [
      { value: "Wholesaler/Distributor", title: "Wholesaler/Distributor" },
      { value: "Past Student Referral", title: "Past Student Referral" },
      { value: "Society Referral", title: "Society Referral" },
      { value: "Department Referral", title: "Department Referral" },
      { value: "Helpdesk", title: "Helpdesk" },
    ],
  },
  {
    value: "Social Media",
    title: "Social Media",
    children: [
      { value: "Facebook", title: "Facebook" },
      { value: "Instagram", title: "Instagram" },
      { value: "WhatsApp", title: "WhatsApp" },
    ],
  },
  { value: "Public Form", title: "Public Form" },
];

export const LEAD_SOURCE_PARENTS = LEAD_SOURCE_TREE.map((s) => s.value);
